import React, { useRef } from 'react';

import { FormikHelpers } from 'formik';

import OnboardingSelect from 'components/Selects/OnboardingSelect';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { Error } from './styles';

interface Props {
  id?: string;
  type?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  formik?: FormikHelpers<string>;
}

const BedSelector = ({ value, formik, error, disabled }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const { t } = useStoreTranslation();
  const BED_TYPES = [
    { id: '', name: t('bedSelector.noPrefer') },
    { id: 'Double', name: t('bedSelector.double') },
    { id: 'Queen', name: t('bedSelector.queen') },
    { id: 'King', name: t('bedSelector.king') },
  ];

  const handleChange = (newValue: any) => formik?.setFieldValue('bedType', newValue);

  return (
    <div ref={ref}>
      <OnboardingSelect
        disabled={disabled}
        title={t('bedSelector.title')}
        options={BED_TYPES}
        value={value}
        onChange={handleChange}
      />
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default BedSelector;
